
<div class="v-flex">
    <div style = "width: 25px;">
        <slot name="icon" />
    </div>

    <div
        class = "primary--text c-entry-name"
    >
        {{ entry.name }}
    </div>
</div>
